import { useEffect } from "react";

export default function LinkedInSuccess() {

    useEffect(() => {

        const params = new URLSearchParams(
            window.location.search
        );

        const user = {
            linkedinId: params.get("id"),
            name: params.get("name"),
            email: params.get("email"),
            picture: params.get("picture")
        };

        console.log(user);

        // localStorage.setItem(
        //     "linkedinUser",
        //     JSON.stringify(user)
        // );

    }, []);

    return (
        <div>
            LinkedIn Login Successful
        </div>
    );
}